import differenceInDays from 'date-fns/differenceInDays'
import differenceInMonths from 'date-fns/differenceInMonths'
import differenceInWeeks from 'date-fns/differenceInWeeks'
import differenceInYears from 'date-fns/differenceInYears'
import { enumerated } from './enumerated'
import date, { formatDate, parseDate, stringifyDate } from './date'
import week, { formatFirstDayOfWeek, formatLastDayOfWeek, parseWeek, stringifyWeek } from './week'
import month, { formatMonth, parseMonth, stringifyMonth } from './month'
import year, { formatYear, parseYear, stringifyYear } from './year'
import errors from '../error'
import { z } from 'zod'

export type IntervalUnit =
  | 'milliseconds'
  | 'seconds'
  | 'minutes'
  | 'hours'
  | 'days'
  | 'weeks'
  | 'months'
  | 'years'

const defaultIntervalShape = z.object({
  valueInSeconds: z.number(),
  unit: enumerated({
    milliseconds: 'Milissegundos',
  }).optional(),
})

export default function interval(shape?: z.ZodObject<any>): z.ZodObject<any> {
  return shape ? defaultIntervalShape.merge(shape) : defaultIntervalShape
}

export const intervalsAndDifferenceFunctions = {
  milliseconds: undefined,
  seconds: undefined,
  minutes: undefined,
  hours: undefined,
  days: differenceInDays,
  weeks: differenceInWeeks,
  months: differenceInMonths,
  years: differenceInYears,
}

export const intervalsAndTypes = {
  milliseconds: undefined,
  seconds: undefined,
  minutes: undefined,
  hours: undefined,
  days: date,
  weeks: week,
  months: month,
  years: year,
}

export const intervalsAndParsers = {
  milliseconds: undefined,
  seconds: undefined,
  minutes: undefined,
  hours: undefined,
  days: parseDate,
  weeks: parseWeek,
  months: parseMonth,
  years: parseYear,
}

export const intervalsAndStringifyFunctions = {
  milliseconds: undefined,
  seconds: undefined,
  minutes: undefined,
  hours: undefined,
  days: stringifyDate,
  weeks: stringifyWeek,
  months: stringifyMonth,
  years: stringifyYear,
}

export const intervalsAndShortFormatFunctions = {
  milliseconds: undefined,
  seconds: undefined,
  minutes: undefined,
  hours: undefined,
  days: formatDate,
  weeks: (date: Date) => `${formatFirstDayOfWeek(date)} à ${formatLastDayOfWeek(date)}`,
  months: formatMonth,
  years: formatYear,
}

const intervalsArray: IntervalUnit[] = [
  'milliseconds',
  'seconds',
  'minutes',
  'hours',
  'days',
  'weeks',
  'months',
  'years',
]

export function isIntervalGreaterOrEqualTo(left: IntervalUnit, right: IntervalUnit) {
  const indexOfLeft = intervalsArray.indexOf(left)
  const indexOfRight = intervalsArray.indexOf(right)

  if (indexOfLeft === -1 || indexOfRight === -1) {
    throw errors.validation('Unidade de intervalo desconhecida')
  }

  return indexOfLeft >= indexOfRight
}

export function isIntervalLessOrEqualTo(left: IntervalUnit, right: IntervalUnit) {
  const indexOfLeft = intervalsArray.indexOf(left)
  const indexOfRight = intervalsArray.indexOf(right)

  if (indexOfLeft === -1 || indexOfRight === -1) {
    throw errors.validation('Unidade de intervalo desconhecida')
  }

  return indexOfLeft <= indexOfRight
}
